'use client';

import { Button, type ButtonProps } from '@/components/ui/button';
import { cn } from '@/shared/utils/formatting';
import { Loader2 } from 'lucide-react';

interface FlowCtaProps extends Omit<ButtonProps, 'variant' | 'size'> {
  loading?: boolean;
}

/** Full-width 52px primary action from the design handoff (`.tf-cta`). */
export function FlowCta({
  loading = false,
  disabled,
  className,
  children,
  ...props
}: FlowCtaProps) {
  return (
    <Button
      {...props}
      disabled={disabled || loading}
      aria-busy={loading}
      className={cn(
        'h-[52px] w-full rounded-[2px] bg-red-primary text-[15px] font-bold text-white transition-[background-color,box-shadow,opacity] hover:bg-red-hover hover:shadow-[0_0_0_4px_rgba(171,0,19,0.18)] active:scale-[0.99] disabled:opacity-35 disabled:shadow-none disabled:hover:bg-red-primary [&_svg]:size-4',
        className
      )}
    >
      {loading ? <Loader2 className="animate-spin" aria-hidden /> : children}
    </Button>
  );
}
